<template>
  <nav
    id="navigation"
    class="navigation"
  >
    <ul class="navigation-list">
      <li
        v-if="searchAction"
        class="navigation-list-item navigation-list-item--search mb-4 mb:mb-0"
      >
        <kf-search-bar
          class="search-bar-wrapper-small"
          :search-action="searchAction"
          :search-placeholder="searchPlaceholder"
        />
      </li>
      <li
        v-for="(item, index) in validNavItems"
        :key="index"
        class="navigation-list-item"
      >
        <a
          :href="`${item.UrlSegment}`"
          class="navigation-list-link"
          @click="scrollToElementIfLinkIsLocal(item.UrlSegment, $event)"
        >
          {{ item.Name }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import KfSearchBar from '@/components/search/SearchBar.vue';

export default {
  name: 'TheNavigation',
  components: {
    KfSearchBar,
  },
  props: {
    navItems: {
      type: Array,
      default: null,
    },
    searchAction: {
      type: String,
      default: null,
    },
    searchPlaceholder: {
      type: String,
      default: null,
    },
  },
  computed: {
    validNavItems() {
      return this.navItems?.filter((navItem) => {
        return navItem.Name && navItem.UrlSegment && navItem.UrlSegment !== '#';
      });
    },
  },
  methods: {
    scrollToElementIfLinkIsLocal(url, event) {
      if (url.startsWith('#')) {
        const targetElement = document.querySelector(url);

        event.preventDefault();

        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    },
  },
};
</script>

<style lang="postcss">
.navigation {
  @apply w-full items-center flex-1 absolute z-10 pt-12;
  transform: translateY(-100%);
  transition: all 300ms;
  overflow: hidden;
  left: 0;
  top: 0;
  opacity: 0;

  @screen lg {
    @apply relative h-full top-auto flex pt-5;
    transform: translateY(0);
    overflow: inherit;
    opacity: 1;
  }

  &.is-open {
    @apply bg-white opacity-100;
    transform: translateY(0);
    top: 40px;
    box-shadow: 0 4px 20px rgb(54 25 5 / 12%);

    @screen lg {
      @apply top-0 bg-transparent;
      box-shadow: none;
    }
  }

  &-list {
    @apply h-full items-start flex flex-col px-4 list-none;

    @screen md {
      @apply pt-14;
    }

    @screen lg {
      @apply flex-row pt-0 px-0;
    }

    &-item {
      @apply relative w-full flex flex-col items-center justify-center text-lg;

      @screen lg {
        @apply h-full mr-10 w-auto;
      }

      &--search {
        @apply justify-end md:hidden;
      }
    }

    &-link {
      @apply w-full text-primary-bravo font-bold mb-4 block no-underline;

      @screen lg {
        @apply font-normal mb-0 inline text-black;
        .theme-secondary & {
        @apply mb-0 inline text-black;
      }
        &::after {
          content: '';
          display: block;
          width: 0;
          height: 4px;
          border-radius: 1px;
          background: #ef575d;
          transition: width 0.3s;
          position: absolute;
          bottom: -1px;
        }

        &:hover {
          @apply no-underline;

          &::after {
            width: 100%;
          }
        }
      }
    }
  }

  .search-bar-wrapper-small {
    @apply flex mb-2;

    @screen lg {
      @apply hidden;
    }
  }
}
</style>
